import React, { useState } from "react";
import {
   Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button,TextField, InputLabel
} from "@mui/material";
import expStyles from "./FundExpenseDetail.module.scss"

const ReasonModel = ({setShowRason, showReason, handleApproveRecipet }: any) => {
    const [error, setErrors] = useState(false)
    const [val, setVal] = useState('')

    const handleApprove = () => {
        if(val.length === 0){ 
            setErrors(true)
            return
        }
        handleApproveRecipet(val)
        setShowRason(false)
    }
    return(
  <Dialog onClose={() => setShowRason(false)}
                fullWidth
                maxWidth="md"
                open={showReason} className={expStyles.customDialog}>
                <DialogTitle>Receipts Preview</DialogTitle>
                <DialogContent
                    sx={{
                        overflowY: 'auto',
                    }}
                >
                 <InputLabel shrink sx={{ fontSize: "1rem", fontFamily: 'Poppins, sans-serif' }} error={error} required={true}>Reason </InputLabel>
                 <TextField
                    fullWidth
                    error={error}
                    onChange={(e) => setVal(e.target.value)}
                    helperText={error && "Please specify valid reason"}
                />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="info" onClick={() => handleApprove()}>Submit</Button>
                    <Button variant="contained" color="error" onClick={() => setShowRason(false)}>Close</Button>
                </DialogActions>
            </Dialog>
)}

export default ReasonModel